export default __webpack_public_path__ + "static/media/icon-kelas.9a4e0a4d.png";